// extracted by mini-css-extract-plugin
export default {"reports_wrapper":"Reports_reports_wrapper__GHpAj","reports_container":"Reports_reports_container__RlSRt"};